const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index
}

export default (array = []) => {
  if (!array) {
    return []
  }

  return array.filter(onlyUnique)
}
